import React, {FC} from "react";
import {
    IconButton,
    Tooltip,
} from "@mui/material";
import {Compare} from "@mui/icons-material";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";

interface IAddToCompareListButton {
    onClick: () => void;
    isAddedToList: boolean;
    mobileMode: boolean;
}

export const AddToCompareListButton: FC<IAddToCompareListButton> = ({
    onClick,
    isAddedToList,
    mobileMode,
}) => {
    const toolTipTitle = isAddedToList ?
        <Locale localeId={IdlocaGeneric.remove_from_compare_list}/> :
        <Locale localeId={IdlocaGeneric.add_to_compare_list}/>;
    return (
        <Tooltip title={toolTipTitle} arrow>
            <IconButton
                color={isAddedToList ? "success" : "secondary"}
                onClick={onClick}
                aria-label={"add to compare list"}
                sx={{
                    transition: "opacity 0.3s, transform 0.3s",
                    opacity: mobileMode ? 1 : 0,
                    transform: mobileMode ? "translateY(0)" : "translateY(-10px)",
                }}
            >
                <Compare/>
            </IconButton>
        </Tooltip>
    );
};
